/* import __COLOCATED_TEMPLATE__ from './subunit-search-input.hbs.js'; */
var _dec, _dec2, _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { action, computed } from '@ember/object';
import Component from '@ember/component';
import { isEmpty } from '@ember/utils';
import { debounce } from '@ember/runloop';

/**

## SubunitSearchInput

Input to search and select subunits

### Params
@param {Array<Subunit>} subunits - Subunits to select from to assign device
@param {Action} onSubunitChange - Action to call when setting subunit

*/
const INPUT_DEBOUNCE_TIME = 150;
let SubunitSearchInput = (_dec = computed('subunits.@each.nickname').readOnly(), _dec2 = computed('sortedSubunits.@each.nickname').readOnly(), (_class = class SubunitSearchInput extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, 'data-test-subunit-search-input', true);
    _defineProperty(this, "value", null);
    _defineProperty(this, "lastSelectedValue", null);
    _defineProperty(this, "searchText", '');
  }
  init() {
    super.init();
    this.set('options', this.allSubunitOptions);
  }
  get sortedSubunits() {
    return this.subunits.sort((a, b) => a.nickname.localeCompare(b.nickname));
  }
  get allSubunitOptions() {
    return this.sortedSubunits.map(unit => {
      return {
        label: unit.nickname,
        value: unit
      };
    });
  }
  filterOptions() {
    /*
       NB: setting `device.subunit` to null here is a workaround for an interaction where
        1. The user selects an option
       2. They type something else into the search box
       3. They click create
       4. The device creation is successful and uses the selected option
        Since we're not sure if the user actually wanted to change the location and just forgot to select the option,
       this makes sure that validations fail when that happens. The value / label will then snap back to the previously
       selected option ( this happens in dropdownClosed() ).
    */
    this.onSubunitChange(null);
    const options = this.options;
    const text = this.searchText;
    const filter = text.toLowerCase();
    const substringMatches = options.filter(option => option.label.toLowerCase().includes(filter));
    this.set('options', substringMatches);
  }
  inputCancelled() {
    this.set('options', this.allSubunitOptions);
  }
  dropdownClosed() {
    this.set('options', this.allSubunitOptions);
    const subunit = this.lastSelectedValue;
    this.onSubunitChange(subunit);

    // Refresh the label value, as it gets cleared when the user types something
    if (!isEmpty(subunit)) {
      const nickname = subunit.nickname;
      this.set('value', {
        value: subunit,
        label: nickname
      });
    } else {
      this.set('value', {
        value: null,
        label: null
      });
    }
  }
  onInput(value) {
    const subunits = this.allSubunitOptions;
    if (isEmpty(value)) {
      this.set('options', subunits);
      return;
    }
    const inputLength = value.length;
    if (this.searchText.length > inputLength) {
      this.set('options', subunits);
    }
    this.set('searchText', value);
    debounce(this, this.filterOptions, INPUT_DEBOUNCE_TIME, false);
  }
  onSelect(option) {
    if (isEmpty(option) || isEmpty(option.value)) {
      this.onSubunitChange(null);
    } else {
      this.onSubunitChange(option.value);
      // Hold on to the last legitimate selection
      this.set('lastSelectedValue', option.value);
    }
  }
}, (_applyDecoratedDescriptor(_class.prototype, "sortedSubunits", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "sortedSubunits"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allSubunitOptions", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "allSubunitOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "inputCancelled", [action], Object.getOwnPropertyDescriptor(_class.prototype, "inputCancelled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dropdownClosed", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dropdownClosed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSelect", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSelect"), _class.prototype)), _class));
export { SubunitSearchInput as default };